import React, { useState } from 'react';
import './Footer.css';
import { FaFacebook, FaInstagram, FaYelp, FaGoogle, FaPhone, FaEnvelope } from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';
import { scrollToSection } from '../../utils/scrollToSection';
import YelpModal from '../ui/YelpModal';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isYelpModalOpen, setIsYelpModalOpen] = useState(false);
  
  // Check if we're on the home page
  const isHomePage = location.pathname === '/';

  const handleYelpClick = (e) => {
    e.preventDefault();
    setIsYelpModalOpen(true);
  };
  
  return (
    <footer className="footer">
      <div className="container pad-h-6">
        {/* Desktop Footer - Full Details */}
        <div className="footer-content desktop-footer">
          <div className="footer-section">
            <div className="footer-brand">
              <img src="/images/logos/RC Remodel Yellow BG.jpg" alt="RC Remodel Logo" className="footer-logo" />
              <h3>RC Remodel</h3>
            </div>
            <p className="pad-r-16">
              Transforming homes with exceptional craftsmanship and attention to detail. 
              Your dream home is just a call away.
            </p>
            <div className="social-links">
              <a href="https://www.facebook.com/profile.php?id=61574085062006" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebook aria-hidden="true" />
              </a>
              <a href="https://www.instagram.com/rcremodels?igsh=MXU1bnQ5cjFmbm11YQ%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FaInstagram aria-hidden="true" />
              </a>
              <a href="https://www.google.com/search?sca_esv=c9bfdf3b8cae865b&hl=en&authuser=0&sxsrf=AE3TifPDM3Ol_ow1rTGMUIRgwhrmU61Kvw:1759293247026&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-EzuQ3ppSlrXGcwVjVa_bVhBBa_K1m_PhUX93-hbnm5G7PtosDXz4RjQG9qYZLwRbUVK6TWBfyW1C-uoiVviAO13Q4fFa&q=RC+Remodel+Reviews&sa=X&ved=2ahUKEwjyyq2IloKQAxVoavUHHetZEzoQ0bkNegQIHxAC&biw=2560&bih=945&dpr=1" target="_blank" rel="noopener noreferrer" aria-label="Find us on Google Maps">
                <FaGoogle aria-hidden="true" />
              </a>
              <a href="#" onClick={handleYelpClick} aria-label="Yelp Reviews">
                <FaYelp aria-hidden="true" />
              </a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              {isHomePage ? (
                // Home page - show all sections with scroll functionality
                <>
                  <li>
                    <a href="#home" onClick={(e) => { 
                      e.preventDefault(); 
                      scrollToSection('home');
                    }}>Home</a>
                  </li>
                  <li>
                    <a href="#services" onClick={(e) => { 
                      e.preventDefault(); 
                      scrollToSection('services');
                    }}>Services</a>
                  </li>
                  <li>
                    <a href="#portfolio" onClick={(e) => { 
                      e.preventDefault(); 
                      scrollToSection('portfolio');
                    }}>Portfolio</a>
                  </li>
                  <li>
                    <a href="#reviews" onClick={(e) => { 
                      e.preventDefault(); 
                      scrollToSection('reviews');
                    }}>Reviews</a>
                  </li>
                  <li>
                    <a href="#about" onClick={(e) => { 
                      e.preventDefault(); 
                      scrollToSection('about');
                    }}>About</a>
                  </li>
                  <li>
                    <a href="#contact" onClick={(e) => { 
                      e.preventDefault(); 
                      scrollToSection('contact');
                    }}>Contact</a>
                  </li>
                  <li><a href="/faq" onClick={(e) => { e.preventDefault(); navigate('/faq'); }}>FAQs</a></li>
                  <li><a href="/privacy-policy" onClick={(e) => { e.preventDefault(); navigate('/privacy-policy'); }}>Privacy Policy</a></li>
                </>
              ) : (
                // Other pages - show only main navigation links
                <>
                  <li><a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }}>Home</a></li>
                  <li><a href="/all-services" onClick={(e) => { e.preventDefault(); navigate('/all-services'); }}>Services</a></li>
                  <li><a href="/gallery" onClick={(e) => { e.preventDefault(); navigate('/gallery'); }}>Portfolio</a></li>
                  <li><a href="/faq" onClick={(e) => { e.preventDefault(); navigate('/faq'); }}>FAQs</a></li>
                  <li><a href="/gc-services" onClick={(e) => { e.preventDefault(); navigate('/gc-services'); }}>General Contractor</a></li>
                  <li><a href="/privacy-policy" onClick={(e) => { e.preventDefault(); navigate('/privacy-policy'); }}>Privacy Policy</a></li>
                </>
              )}
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-info">
              <p><FaPhone className="contact-icon" aria-hidden="true" /> <a href="tel:+13136316020">313-631-6020</a></p>
              <p><FaEnvelope className="contact-icon" aria-hidden="true" /> <a href="mailto:hi@rcremodel.com">hi@rcremodel.com</a></p>
            </div>
          </div>
        </div>

        {/* Mobile/Tablet Footer - Minimal Details */}
        <div className="footer-content mobile-footer">
          <div className="footer-section">
            <div className="footer-brand d-block">
              <h3>RC Remodel</h3>
            </div>

            {/* Mobile Navigation Links */}
            <div className="mobile-nav-links">
              <a href="#home" onClick={(e) => { 
                e.preventDefault(); 
                if (isHomePage) {
                  scrollToSection('home');
                } else {
                  navigate('/');
                }
              }}>Home</a>
              <span className="nav-separator">|</span>
              <a href="#services" onClick={(e) => { 
                e.preventDefault(); 
                if (isHomePage) {
                  scrollToSection('services');
                } else {
                  navigate('/all-services');
                }
              }}>Services</a>
              <span className="nav-separator">|</span>
              <a href="#portfolio" onClick={(e) => { 
                e.preventDefault(); 
                if (isHomePage) {
                  scrollToSection('portfolio');
                } else {
                  navigate('/gallery');
                }
              }}>Portfolio</a>
              <span className="nav-separator">|</span>
              <a href="/gc-services" onClick={(e) => { e.preventDefault(); navigate('/gc-services'); }}>General Contractor</a>
              <span className="nav-separator">|</span>
              <a href="/faq" onClick={(e) => { e.preventDefault(); navigate('/faq'); }}>FAQs</a>
              <span className="nav-separator">|</span>
              <a href="/privacy-policy" onClick={(e) => { e.preventDefault(); navigate('/privacy-policy'); }}>Privacy Policy</a>
            </div>

            <div className="contact-info margin-b-6">
              <p><FaPhone className="contact-icon" aria-hidden="true" /> <a href="tel:+13136316020">313-631-6020</a></p>
              <p><FaEnvelope className="contact-icon" aria-hidden="true" /> <a href="mailto:hi@rcremodel.com">hi@rcremodel.com</a></p>
            </div>
            
            <div className="social-links">
              <a href="https://www.facebook.com/profile.php?id=61574085062006" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebook aria-hidden="true" />
              </a>
              <a href="https://www.instagram.com/rcremodels?igsh=MXU1bnQ5cjFmbm11YQ%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FaInstagram aria-hidden="true" />
              </a>
              <a href="https://www.google.com/search?sca_esv=c9bfdf3b8cae865b&hl=en&authuser=0&sxsrf=AE3TifPDM3Ol_ow1rTGMUIRgwhrmU61Kvw:1759293247026&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-EzuQ3ppSlrXGcwVjVa_bVhBBa_K1m_PhUX93-hbnm5G7PtosDXz4RjQG9qYZLwRbUVK6TWBfyW1C-uoiVviAO13Q4fFa&q=RC+Remodel+Reviews&sa=X&ved=2ahUKEwjyyq2IloKQAxVoavUHHetZEzoQ0bkNegQIHxAC&biw=2560&bih=945&dpr=1" target="_blank" rel="noopener noreferrer" aria-label="Find us on Google Maps">
                <FaGoogle aria-hidden="true" />
              </a>
              <a href="#" onClick={handleYelpClick} aria-label="Yelp Reviews">
                <FaYelp aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2025 RC Remodel. All rights reserved.</p>
        </div>
      </div>
      
      <YelpModal 
        isOpen={isYelpModalOpen}
        onClose={() => setIsYelpModalOpen(false)}
      />
    </footer>
  );
};

export default Footer;
